// src/pages/personal/analytics/DashboardPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import DashboardSection from './DashboardSection/DashboardSection';

const DashboardPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <DashboardSection />
    </AdaptiveLayout>
  );
};

export default DashboardPage;